// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4de0fb10","885":"e7b24c73"}[chunkId] + ".chunk.js";
};